import log from 'salvo-lite/log'

class Video {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._video = elem.querySelector('video')
        this._pause = elem.querySelector('[data-pause-video]')
        this._play = elem.querySelector('[data-play-video]')
        this._progress = elem.querySelector('[data-progress]')
        this._circle = ''
        this._radius = ''
        this._circumference = ''
        this._parent = null
        log.debug(this.constructor.name, 'Constructed', this)
    }
    onInit () {
        const identifier = this._elem.getAttribute('data-video')
        if (identifier) {
            this._parent = document.querySelector(identifier)
        }
        if (this._progress) {
            this._circle = this._progress.querySelector('circle')
            this._radius = this._circle.getAttribute('r')
            this._circumference = this._radius * 2 * Math.PI
            this._circle.style.strokeDasharray = `${this._circumference} ${this._circumference}`
            this._circle.style.strokeDashoffset = `${this._circumference}`
        }
        if (this._elem.getAttribute('data-self-trigger')) {
            this._elem.addEventListener('click', e => {
                if (e.target.nodeName === 'VIDEO' || e.target === this._elem) {
                    if (this._video.paused) this._vidPlay()
                    else this._vidPause()
                }
            })
        }
        if (this._play) {
            this._play.addEventListener('click', e => {
                this._vidPlay()
            })
            this._video.addEventListener('ended', e => {
                this._ended()
            })
            this._video.addEventListener('timeupdate', e => {
                this._setProgress()
            })
        }
        if (this._pause) {
            this._pause.addEventListener('click', e => {
                this._vidPause()
            })
        }
        this._video.addEventListener('pauseVideo', e => {
            this._vidPause()
        })
        // if (this._parent) {
        //     let t = this._parent.getAttribute('data-main-slider')
        //     if (!t) {
        //         t = this._parent.getAttribute('data-swiper')
        //     }
        //     const swiper = t
        //     if (swiper) {
        //         const config = { attributes: true, childList: true, subtree: true }
        //         const callback = (mutationsList, observer) => {
        //             for (let mutation of mutationsList) {
        //                 if (this._elem.closest('.swiper-slide').classList.contains('swiper-slide-active')) {
        //                     return
        //                 } else if (!this._video.paused) {
        //                     this._vidPause()
        //                     console.log(mutation)
        //                 }
        //             }
        //         }
        //         let observer = new MutationObserver(callback)
        //         observer.observe(this._elem.closest('.swiper-slide'), config)
        //     }
        // }
        // this._elem.addEventListener('pauseVideo', e => {
        //     this._vidPause()
        // })
    }
    _vidPlay () {
        this._play.classList.add('visually-hidden')
        this._pause.classList.remove('visually-hidden')
        this._video.play()
    }
    _vidPause () {
        this._video.pause()
        this._play.classList.remove('visually-hidden')
        this._pause.classList.add('visually-hidden')
    }
    _ended () {
        this._play.classList.remove('visually-hidden')
        this._pause.classList.add('visually-hidden')
        this._video.load()
    }
    _setProgress () {
        const percent = (100 / this._video.duration) * this._video.currentTime
        const offset = this._circumference - percent / 100 * this._circumference
        this._circle.style.strokeDashoffset = offset
    }
}
export default Video



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Video.js